/**
 * Rotation, in degrees, for the nth icon of a tilted pile. Directions alternate and the amounts
 * vary a little so a stack of connector or plugin icons reads as loosely hand-placed rather than
 * machine-aligned. Deterministic, so a pile looks the same on every render.
 */
const PILE_TILT_DEGREES = [-6, 5, -4, 7, -5, 4];
export const pileTiltDegrees = (index) => PILE_TILT_DEGREES[index % PILE_TILT_DEGREES.length] ?? 0;
//# sourceMappingURL=pileTilt.js.map